import { GATE_CATALOG_ITEM_TYPES } from "../../../enums/gateCatalogItemTypes.enum";

export interface ManufacturerObject {
  id?: string;
  label: string;
}

export class Manufacturer {
  public id?: string;
  label: string;
  public selected = false;
  public gateCatalogItemType: string = GATE_CATALOG_ITEM_TYPES.MANUFACTURER;

  constructor(manufacturer: ManufacturerObject) {
    this.id = manufacturer.id;
    this.label = manufacturer.label;
  }

  public set properties(manufacturer: ManufacturerObject) {
    this.label = manufacturer.label;
  }

  public get values() {
    const manufacturer: ManufacturerObject = {
      label: this.label,
    };

    return manufacturer;
  }
}

// export class ControllerManufacturer extends Manufacturer {}
